export default class VideoObserver {
	constructor(video,options,wrapper) {
		this.video 					= video
		this.wrapper 				= wrapper
		this.hasEntered 			= false
		this.handleIntersection 	= this.handleIntersection.bind(this)
		this.options				= options

		if(!this.options){
			this.options = {
				root: null, // Use the viewport as the root
				rootMargin: '0px', // No additional margin
				threshold: 0, // Trigger when 0 of the video is visible
			}
		} else {
			// ONLY OBSERVE ON MOBILE
			// window.addEventListener("resize", () => {
			// 	if( window.matchMedia("(hover: hover)").matches ){
			// 		console.log(`isHover!`)
			// 		this.video.pause()
			// 		this.disconnect();
			// 	}
			// });
		}

		this.setupOberserver()
	}

	setupOberserver() {

		this.intersectionObserver = new IntersectionObserver(this.handleIntersection, this.options)

		this.intersectionObserver.observe(this.video)

	}

	handleIntersection(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				this.hasEntered = true
				this.video.play()
				if(this.wrapper){
					this.wrapper.classList.add('video--uncovered')
				}
			} else if (!entry.isIntersecting && this.hasEntered) {
				// console.log('Video left the viewport')
				this.video.pause()
				// console.log(`video pausing`)
			}
		})
	}

	disconnect() {
		// Stop observing and disconnect the Intersection Observer
		console.log('disconnecting observer')
		if (this.intersectionObserver) {
			this.intersectionObserver.unobserve(this.video)
		}
	}
}
